import styled from 'styled-components'

export const ResetPasswordConfirmWrapper = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.brand};
  background: ${({ theme }) => `linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`

export const ResetPasswordConfirmInnerWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ResetPasswordConfirmFormWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`

export const ResetPasswordConfirmFormInnerWrapper = styled.div`
  max-width: 500px;
  width: 100%;
`

export const ResetPasswordConfirmFormContent = styled.div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`

export const ResetPasswordConfirmLogoLink = styled.a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`
export const ResetPasswordConfirmTitle = styled.h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 30px 0;
`

export const ResetPasswordConfirmBrandWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`

export const ResetPasswordConfirmBottomWrapper = styled.div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme }) => theme.colors.background};
`

export const PrivacyPolicyLink = styled.a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme }) => theme.colors.primary};
`

export const ResetPasswordConfirmFormFooterText = styled.p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme }) => theme.colors.primary};
  text-align: right;
`

export const ResetPasswordConfirmFormFooterLink = styled.a`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
`

export const FormText = styled.p`
  margin: 0;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  margin: 0 0 30px 0;
`
